import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';

import Loading from '@/_pages/competitors/new/loading';

export const Route = createFileRoute('/_private/competitors/new')({
  validateSearch: (search) => z.object({ from: z.string().optional() }).parse(search),

  pendingComponent: Loading,
});
